import React from 'react'
import bannerBg from '../assets/img/Banners/Media_Gallery.jpg';
import PageBanner from '../Components/PageBanner';
import Gallery from '../Components/Hero/Gallery';
const GalleryShowcase = () => {
  return (
    <>
      <PageBanner title='Media gallery' bannerBg={bannerBg} currentPage='Media gallery  ' />
      <Gallery/>
    </>
  )
}

export default GalleryShowcase
